module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "w3-container w3-top w3-hide-large w3-pink w3-xlarge w3-padding"
  }, [_c('button', {
    staticClass: "w3-button w3-pink w3-margin-right",
    on: {
      "click": _vm.showNavbar
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('div', {
    staticClass: "locale-container"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/flag_hu.png"),
      "alt": "flag hu"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLocale', 'hu')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/flag_en.png"),
      "alt": "flag en"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLocale', 'en')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/flag_de.png"),
      "alt": "flag de"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLocale', 'de')
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baf7896e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = 954
// module chunks = 0